const state = {
  tabIndex: 1,
  formComplete: false,
  materialComplete: false,
  randComplete: false,
  shoppingCartComplete: false,
  addressComplete: false,
  paymentComplete: false
}

const mutations = {
  'INCREASE_TABINDEX' (state) {
    state.tabIndex = 2
  },
  'DECREASE_TABINDEX' (state) {
    state.tabIndex = 1
  },
  'SET_TABINDEX' (state, value) {
    state.tabIndex = value
  },
  'CHANGE_STATUS_FORM' (state) {
    state.formComplete = !state.formComplete
  },
  'CHANGE_STATUS_MATERIAL' (state) {
    state.materialComplete = !state.materialComplete
  },
  'CHANGE_STATUS_RAND' (state) {
    state.randComplete = !state.randComplete
  },
  'CHANGE_STATUS_SHOPPINGCART' (state) {
    state.shoppingCartComplete = !state.shoppingCartComplete
  },
  'CHANGE_STATUS_ADDRESS' (state) {
    state.addressComplete = !state.addressComplete
  },
  'CHANGE_STATUS_PAYMENT' (state) {
    state.paymentComplete = !state.paymentComplete
  },
  'CLEAR_SETUP' (state) {
    state.formComplete = false
    state.materialComplete = false
    state.randComplete = false
  },
  'CLEAR_SUMMARY' (state) {
    state.shoppingCartComplete = false
    state.addressComplete = false
    state.paymentComplete = false
  }
}

const actions = {
  increaseTabIndex: ({ commit }) => {
    commit('INCREASE_TABINDEX')
  },
  decreaseTabIndex: ({ commit }) => {
    commit('DECREASE_TABINDEX')
  },
  setTabIndex: ({ commit }, value) => {
    commit('SET_TABINDEX', value)
  },
  changeStatusForm: ({ commit }) => {
    commit('CHANGE_STATUS_FORM')
  },
  changeStatusMaterial: ({ commit }) => {
    commit('CHANGE_STATUS_MATERIAL')
  },
  changeStatusRand: ({ commit }) => {
    commit('CHANGE_STATUS_RAND')
  },
  changeStatusShoppingCart: ({ commit }) => {
    commit('CHANGE_STATUS_SHOPPINGCART')
  },
  changeStatusAddress: ({ commit }) => {
    commit('CHANGE_STATUS_ADDRESS')
  },
  changeStatusPayment: ({ commit }) => {
    commit('CHANGE_STATUS_PAYMENT')
  },
  clearSetup: ({ commit }) => {
    commit('CLEAR_SETUP')
  },
  clearSummary: ({ commit }) => {
    commit('CLEAR_SUMMARY')
  }
}

const getters = {
  tabIndex: state => {
    return state.tabIndex
  },
  formComplete: state => {
    return state.formComplete
  },
  materialComplete: state => {
    return state.materialComplete
  },
  randComplete: state => {
    return state.randComplete
  },
  shoppingCartComplete: state => {
    return state.shoppingCartComplete
  },
  addressComplete: state => {
    return state.addressComplete
  },
  paymentComplete: state => {
    return state.paymentComplete
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
